import React from 'react'

const Partners = ({ title, data, largeLogos = false }) => {
     const logoHeight = largeLogos ? 90 : 44;
     const logoWidth = largeLogos ? 280 : 173;

     return (
          <div className={`esteemed-partners section-space${largeLogos ? " esteemed-partners--large" : ""}`}>
               <div className="container">
                    <h2>{title}</h2>
                    <ul className="esteemed-icon">
                         {data?.sort((a, b) => a.order - b.order)
                              .map((partner, index) => (
                                   <li key={partner.id}>
                                        <img
                                             src={partner.image}
                                             alt={partner.altText}
                                             height={logoHeight}
                                             width={logoWidth}
                                             loading="lazy"
                                        />
                                   </li>
                              ))}
                    </ul>
               </div>
          </div>
     )
}

export default Partners